import React, { useState, useEffect } from "react";
import { Select } from "@windmill/react-ui";
import AdminServices from "services/AdminServices";

const SelectRole = ({ register, name, label ,onChange  }) => {
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    async function fetchProfiles() {
      try {
        const response = await AdminServices.getAllProfile();
        setProfiles(response?.data); // Assuming the API response contains an array of profiles
      } catch (error) {
        console.error("Error fetching profiles:", error);
      }
    }

    fetchProfiles();
  }, []);

  return (
    <Select
      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
      name={name}
      {...register(`${name}`, {
        required: `${label} is required!`,
      })}
        onChange={(e) => {
        if (onChange) onChange(e); // ✅ send event to parent
      }}
    >
      <option value="" defaultValue hidden>
        Employee role
      </option>
      {Array.isArray(profiles) && profiles.length > 0 ? (
        profiles.map((profile) => (
          <option key={profile.id_profile} value={profile.id_profile}>
            {profile.name}
          </option>
        ))
      ) : (
        <option>Loading...</option>
      )}
    </Select>
  );
};

export default SelectRole;
